import React, { useState } from 'react';
import PropTypes from 'prop-types';

export default function Text({ cellValue, onFocusOut }) {
  const [value, setValue] = useState(cellValue);
  return (
    <textarea
      placeholder="type here"
      name="input"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onBlur={onFocusOut}
    >
      {' '}
    </textarea>
  );
}

Text.propTypes = {
  cellValue: PropTypes.string,
  onFocusOut: PropTypes.func,
};

Text.defaultProps = {
  cellValue: '',
  onFocusOut: () => {},
};
